/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


// The single seam between the action UI and the backend. In rpc mode the command goes
// to the galaxy controller; mock mode logs the assembled payload.
export default (client, type, args, onSuccess = () => {}) =>
{
  client.send('galaxy', type, args).on_complete = (success, error) =>
  {
    if (success)
    {
      onSuccess();
    }
    else
    {
      console.log(type, error);
    }
  };
};
